<template>
  <div class="auth--wrapper">
    <main class="w-100 display-flex flex-wrap" style="min-height: 100vh">
      <section class="register--wrapper display-flex flex-wrap" style="min-height: 100vh">
        <div class="auth--left-panel col-xl-6 col-sm-12"></div>
        <!--<div class="auth&#45;&#45;dropdown-wrapper">-->
          <!--<el-dropdown @command="changeLang"-->
                       <!--trigger="click">-->
          <!--<span class="dropdown&#45;&#45;color" style="font-weight: bold">-->
          <!--{{currentLang}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
          <!--</span>-->
            <!--<el-dropdown-menu slot="dropdown">-->
              <!--<el-dropdown-item command="PL">PL</el-dropdown-item>-->
              <!--<el-dropdown-item command="ENG">ENG</el-dropdown-item>-->
            <!--</el-dropdown-menu>-->
          <!--</el-dropdown>-->
        <!--</div>-->
        <transition
          name="fade"
          mode="out-in"
        >
          <router-view>
          </router-view>
        </transition>
      </section>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'authPanel',
    data() {
      return {
        currentLang: 'PL',
      };
    },
    methods: {
      changeLang(lang) {
        this.currentLang = lang;
      },
    },
  };
</script>

<style scoped lang="scss">
  $images: ('./assets/1.jpg', './assets/2.jpg', './assets/3.jpg', './assets/4.jpg', './assets/5.jpg', './assets/6.jpg', './assets/7.jpg', './assets/8.jpg', './assets/9.jpg', './assets/10.jpg',);

  $img: nth($images, random(length($images)));
  .dropdown--color {
    color: #000;
  }

  .auth--wrapper {
    display: flex;
    align-items: center;
    min-height: 100vh
  }

  .auth--left-panel {
    padding: 3rem 3rem 1rem;
    background-image: url($img);
    background-size: cover;
    min-height: 300px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12);
  }

  .auth--dropdown-wrapper {
    z-index: 2;
    right: 20px;
    top: 20px;
    position: absolute;
  }

  @media (max-width: 1200px) {
    .dropdown--color {
      color: white !important;
    }

  }
</style>
